//Paleta de colores compartida para una ruta de picking (mini-mapa, PDF, y la tarjeta de cada parada) - un
//solo lugar para que las 3 vistas nunca se desincronicen. Vive aparte de VisorRutaPickingMapa.js para que
//TarjetaParadaPicking.js pueda importarla sin crear una dependencia circular entre ambos componentes.
export const PALETA_SEGMENTOS = ["#00BFD6", "#22c55e", "#f59e0b", "#a855f7", "#ec4899", "#0ea5e9", "#84cc16", "#f97316"];
export const colorDeSegmento = (numeroSegmento) => PALETA_SEGMENTOS[(numeroSegmento - 1) % PALETA_SEGMENTOS.length];
// Dos o más tramos caminando por la misma conexión física (encimados).
export const COLOR_ENCIMADO = "#ef4444";
// El tramo/parada hacia donde hay que seguir AHORA MISMO.
export const COLOR_ACTUAL = "#f97316";
